module.exports = __webpack_public_path__ + "img/nsoft.fa894880.png";